import { useSelector } from "react-redux";

export default function useGameDefinition(gameDefId) {
  const gameDefinition = useSelector((state) => state.lobby?.masterGameDefinitions[gameDefId]);

  if (!gameDefinition) {
    console.warn('Missing data at useGameDefinition with gameDefId', gameDefId);
    return {};
  }

  return gameDefinition;
}
